import { __decorate } from "tslib";
import _ from 'lodash';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { WORKSPACE_SERVICE_URI } from '@workspace/shared/constants/envConfig';
let SpaceApiServiceImpl = class SpaceApiServiceImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getSpaces(request) {
        const res = await this.post({
            url: 'space/list',
            data: request,
            uuid: `space-list-${request.type}-${request.label_name}`,
        });
        return res.data;
    }
    async batchRemoveSpaces(data) {
        const res = await this.delete({
            url: 'space/batch-delete',
            data,
        });
        return res.data;
    }
    async getSpaceCapacity(data) {
        const res = await this.get({
            url: 'data/capacity',
            data,
        });
        return res.data;
    }
    async batchRejectSpaces(data) {
        const res = await this.delete({
            url: 'batch-reject-share',
            data,
        });
        return res.data;
    }
    async updateSpace(data) {
        const res = await this.put({
            url: `space/${data.space_id}`,
            data: _.omit(data, 'space_id'),
        });
        return res.data;
    }
    async uploadSpaceIcon(data) {
        const res = await this.post({
            url: 'space-icon',
            data,
        });
        return res.data;
    }
    async transferSpace(data) {
        const res = await this.post({
            url: 'space/transfer',
            data,
        });
        return res.data;
    }
    async querySpaceAdmins(request) {
        const res = await this.get({
            url: `tenant/space/${request.spaceId}/administrator/list`,
        });
        return res.data;
    }
    async createSpace(data) {
        const res = await this.post({
            url: 'space?init_folder=true',
            data,
        });
        return res.data;
    }
    async updateSpaceAdmins(request) {
        const res = await this.put({
            url: `tenant/space/${request.spaceId}/manage/authority`,
            data: _.omit(request, 'spaceId'),
        });
        return res.data;
    }
    async querySpaceGroupPermissions(data) {
        const res = await this.get({
            url: `tenant/space/${data.spaceId}/permission/setting`,
        });
        return res.data;
    }
    async updateSpaceGroupPermissions(data) {
        const res = await this.put({
            url: `tenant/space/${data.spaceId}/permission/setting`,
            data: _.omit(data, 'spaceId'),
        });
        return res.data;
    }
    async querySpaceTemplates() {
        const res = await this.get({
            url: 'space-field-template-list',
        });
        return res.data;
    }
};
SpaceApiServiceImpl = __decorate([
    injectable()
], SpaceApiServiceImpl);
export { SpaceApiServiceImpl };
